import React from 'react'
import { HeaderPopupPage } from '../CreatePopup';
import useStyles from '../style'
import { Grid, Typography } from '@mui/material';
import CkeditorComp from '@components/common/ckeditor/Ckeditor';
const BottomPopup = ()=>{
    const classes = useStyles();
    return (
        <>
            <HeaderPopupPage path='/admin/popup-management'/>
            <div className={classes.root}>
                <Grid container display='flex' alignItems='center' justifyContent='center' direction='column'>
                    <Grid item>
                        <Typography className={classes.title}>
                            Popup Bottom
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.text}>
                            Popup nằm ở vị trí phía dưới của website
                        </Typography>
                    </Grid>
                </Grid>
                <CkeditorComp 
                    title="Popup Bottom" 
                    content="Popup nằm ở vị trí phía dưới của website"
                    isBottom={true}
                    popupType="Bottom"
                />
            </div>
        </>
    )
}
export default BottomPopup;
